<template>
    <div class="container">
        <div class="top-banner">
            <div style="float: left">
                <span style="margin-right: 20px">工单详细</span>
                <span>本单应收款：</span>
                <span style="margin-right: 10px;color: #f3ce5c">￥{{ orderInfo.receivablePrice }}</span>
                <span>本单实收款：</span>
                <span style="margin-right: 10px;color: #f3ce5c">￥{{ orderInfo.actualPrice }}</span>
                <span>本单减免金额：</span>
                <span style="color: #f3ce5c">￥{{ orderInfo.reducePrice }}</span>
            </div>
            <div class="back-button" @click="onClose()">
                <Icon type="ios-undo"/>
                <span>返回</span>
            </div>
        </div>
        <div class="car-info">
            <div>
                <span style="font-size: 16px;font-weight: bold">{{ orderInfo.carPlateNumber }}</span>
                <div class="order-type">
                    {{ orderInfo.repairTypeName }}
                </div>
                <div class="order-status" :style="{background: statusBackground}">
                    {{ getStatusText() }}
                </div>
                <div class="print-button" @click="modalPrint = true">
                    <Icon type="md-print" style="color:#044aa1;margin-right: 3px;"/>
                    <span>打印</span>
                </div>
            </div>
            <div style="margin-top: 3px;">
                <span class="car-brand">{{ carInfo.carBrand }}</span>
                <span class="car-brand">{{ carInfo.carSeries }}</span>
                <span class="car-brand">{{ carInfo.displacement }}</span>
                <span class="car-brand">{{ carInfo.productYear }}</span>
            </div>
            <div class="car-info-detail">
                <Row>
                    <Col class="car-info-title" span="2">
                        VIN:
                    </Col>
                    <Col class="car-info-value" span="4">
                        {{ carInfo.vinCode }}
                    </Col>
                    <Col class="car-info-title" span="2">
                        客户名称:
                    </Col>
                    <Col class="car-info-value" span="4">
                        {{ memberInfo.name }}
                    </Col>
                    <Col class="car-info-title" span="2">
                        联系电话:
                    </Col>
                    <Col class="car-info-value" span="4">
                        {{ orderInfo.memberPhone }}
                    </Col>
                    <Col class="car-info-title" span="2">
                        服务顾问:
                    </Col>
                    <Col class="car-info-value" span="4">
                        {{ orderInfo.createUserName }}
                    </Col>
                </Row>
                <Row style="margin-top: 10px">
                    <Col class="car-info-title" span="2">
                        车辆类型:
                    </Col>
                    <Col class="car-info-value" span="4">
                        {{ carInfo.carTypeName }}
                    </Col>
                    <Col class="car-info-title" span="2">
                        登记日期:
                    </Col>
                    <Col class="car-info-value" span="4">
                        {{ orderInfo.receiveDate }}
                    </Col>
                    <Col class="car-info-title" span="2">
                        进厂里程:
                    </Col>
                    <Col class="car-info-value" span="4">
                        {{ orderInfo.entryMileage }}KM
                    </Col>
                    <Col class="car-info-title" span="2">
                        初定提车:
                    </Col>
                    <Col class="car-info-value" span="4">
                        {{ orderInfo.preCompleteDate }}
                    </Col>
                </Row>
            </div>
        </div>
        <div class="big-title">
            <span>工单结算</span>
        </div>
        <div class="table-container">
            <div class="table-left-title">
                工单项目
            </div>
            <div class="table-content" style="border-bottom: none">
                <Row class="table-row table-header">
                    <Col span="2">
                        <span>序号</span>
                    </Col>
                    <Col span="5" class="cell-border-both">
                        <span>项目名称</span>
                    </Col>
                    <Col span="6">
                        <span>施工人员</span>
                    </Col>
                    <Col span="3" class="cell-border-both">
                        <span>计价方式</span>
                    </Col>
                    <Col span="2">
                        <span>工时</span>
                    </Col>
                    <Col span="2" class="cell-border-both">
                        <span>单价</span>
                    </Col>
                    <Col span="2">
                        <span>数量</span>
                    </Col>
                    <Col span="2" class="cell-border-left">
                        <span>总价</span>
                    </Col>
                </Row>
                <Row class="table-row" v-for="(item, index) in itemList" :key="index">
                    <Col span="2">
                        <span>{{ index + 1 }}</span>
                    </Col>
                    <Col span="5" class="cell-border-both">
                        <span>{{ item.name }}</span>
                    </Col>
                    <Col span="6">
                        <span>{{ item.userInfoList.map(u => u.name).join(', ') }}</span>
                    </Col>
                    <Col span="3" class="cell-border-both">
                        <span>{{ getPriceMethodText(item.priceMethod) }}</span>
                    </Col>
                    <Col span="2">
                        <span>{{ item.preManhour }}</span>
                    </Col>
                    <Col span="2" class="cell-border-both">
                        <span v-if="item.priceMethod === 1">￥{{ item.unitPrice }}</span>
                    </Col>
                    <Col span="2">
                        <span>{{ item.count }}</span>
                    </Col>
                    <Col span="2" class="cell-border-left">
                        <span>￥{{ item.totalPrice }}</span>
                    </Col>
                </Row>
                <Row class="table-row">
                    <Col span="2" style="font-weight: bold">
                        <span>小计</span>
                    </Col>
                    <Col span="5" class="cell-border-both">
                        <span></span>
                    </Col>
                    <Col span="6">
                        <span></span>
                    </Col>
                    <Col span="3" class="cell-border-both">
                        <span></span>
                    </Col>
                    <Col span="2" style="font-weight: bold">
                        <span>{{ getManHourTotal() }}</span>
                    </Col>
                    <Col span="2" class="cell-border-both">
                        <span></span>
                    </Col>
                    <Col span="2" style="font-weight: bold">
                        <span>{{ getItemTotalCount() }}</span>
                    </Col>
                    <Col span="2" class="cell-border-left" style="font-weight: bold">
                        <span>￥{{ getItemTotalPrice() }}</span>
                    </Col>
                </Row>
            </div>
        </div>
        <div class="table-container">
            <div class="table-left-title" style="border-top: none">
                工单材料
            </div>
            <div class="table-content" style="border-top: none">
                <Row class="table-row table-header">
                    <Col span="3">
                        <span>序号</span>
                    </Col>
                    <Col span="6" class="cell-border-both">
                        <span>材料名称</span>
                    </Col>
                    <Col span="3">
                        <span>单位</span>
                    </Col>
                    <Col span="4" class="cell-border-both">
                        <span>数量</span>
                    </Col>
                    <Col span="4">
                        <span>销售单价</span>
                    </Col>
                    <Col span="4" class="cell-border-both">
                        <span>销售总价</span>
                    </Col>
                </Row>
                <Row class="table-row" v-for="(mater, index) in materList" :key="index">
                    <Col span="3">
                        <span>{{ index + 1 }}</span>
                    </Col>
                    <Col span="6" class="cell-border-both">
                        <span>{{ mater.name }}</span>
                    </Col>
                    <Col span="3">
                        <span>{{ mater.unitName }}</span>
                    </Col>
                    <Col span="4" class="cell-border-both">
                        <span>{{ mater.count }}</span>
                    </Col>
                    <Col span="4">
                        <span>￥{{ mater.actualSellPrice }}</span>
                    </Col>
                    <Col span="4" class="cell-border-both">
                        <span>￥{{ getItemMaterTotalPrice(mater) }}</span>
                    </Col>
                </Row>
                <Row class="table-row">
                    <Col span="3" style="font-weight: bold">
                        <span>小计</span>
                    </Col>
                    <Col span="6" class="cell-border-both">
                        <span></span>
                    </Col>
                    <Col span="3">
                        <span></span>
                    </Col>
                    <Col span="4" class="cell-border-both">
                        <span>{{ getMaterTotalCount() }}</span>
                    </Col>
                    <Col span="4" style="font-weight: bold">
                        <span></span>
                    </Col>
                    <Col span="4" class="cell-border-left" style="font-weight: bold">
                        <span>￥{{ getMaterTotalPrice() }}</span>
                    </Col>
                </Row>
            </div>
        </div>
        <div class="table-container">
            <div class="table-left-title" style="border-top: none">
                结算价格
            </div>
            <div class="table-content" style="border-top: none">
                <Row class="table-row table-header">
                    <Col span="2">
                        <span>序号</span>
                    </Col>
                    <Col span="8" class="cell-border-both">
                        <span>名称</span>
                    </Col>
                    <Col span="6">
                        <span>金额</span>
                    </Col>
                    <Col span="4" class="cell-border-both">
                        <span>折扣</span>
                    </Col>
                    <Col span="4">
                        <span>应付金额</span>
                    </Col>
                </Row>
                <Row class="table-row">
                    <Col span="2">
                        <span>1</span>
                    </Col>
                    <Col span="8" class="cell-border-both">
                        <span>工时费</span>
                    </Col>
                    <Col span="6">
                        <span>￥{{ orderInfo.workPrice }}</span>
                    </Col>
                    <Col span="4" class="cell-border-both">
                        <span>{{ orderInfo.discountWork }}%</span>
                    </Col>
                    <Col span="4">
                        <span>￥{{ orderInfo.discountWorkPrice }}</span>
                    </Col>
                </Row>
                <Row class="table-row">
                    <Col span="2">
                        <span>1</span>
                    </Col>
                    <Col span="8" class="cell-border-both">
                        <span>材料费</span>
                    </Col>
                    <Col span="6">
                        <span>￥{{ orderInfo.materPrice }}</span>
                    </Col>
                    <Col span="4" class="cell-border-both">
                        <span>{{ orderInfo.discountMater }}%</span>
                    </Col>
                    <Col span="4">
                        <span>￥{{ orderInfo.discountMaterPrice }}</span>
                    </Col>
                </Row>
                <Row class="table-row">
                    <Col span="2" style="font-weight: bold">
                        <span>小计</span>
                    </Col>
                    <Col span="8" class="cell-border-both">
                        <span></span>
                    </Col>
                    <Col span="6" style="font-weight: bold">
                        <span>￥{{ orderInfo.workPrice + orderInfo.materPrice }}</span>
                    </Col>
                    <Col span="4" class="cell-border-both">
                        <span></span>
                    </Col>
                    <Col span="4" style="font-weight: bold">
                        <span>￥{{ orderInfo.discountWorkPrice + orderInfo.discountMaterPrice }}</span>
                    </Col>
                </Row>
            </div>
        </div>
        <div class="big-title">
            <span>工单收银</span>
        </div>
        <div class="table-container">
            <div class="table-left-title">
                收银明细
            </div>
            <div class="table-content">
                <Row class="table-row table-header">
                    <Col span="4">
                        <span>序号</span>
                    </Col>
                    <Col span="10" class="cell-border-both">
                        <span>名称</span>
                    </Col>
                    <Col span="10">
                        <span>金额</span>
                    </Col>
                </Row>
                <Row class="table-row" v-for="(item,index) in receivePrice" :key="index">
                    <Col span="4">
                        <span>1</span>
                    </Col>
                    <Col span="10" class="cell-border-both">
                        <span v-if="item.type==='挂账'" style="color: #e82854">{{ item.type }}</span>
                        <span v-else>{{ item.type }}</span>
                    </Col>
                    <Col span="10">
                        <span v-if="item.type==='挂账'" style="color: #e82854">￥{{ item.price }}</span>
                        <span v-else>￥{{ item.price }}</span>
                    </Col>
                </Row>
                <Row class="table-row">
                    <Col span="4" style="font-weight: bold">
                        <span>小计</span>
                    </Col>
                    <Col span="10" class="cell-border-both">
                        <span></span>
                    </Col>
                    <Col span="10" style="font-weight: bold">
                        <span>￥{{ orderInfo.actualPrice }}</span>
                    </Col>
                </Row>
            </div>
        </div>
        <Modal
            v-model="modalPrint"
            fullscreen
            :closable="false"
            footer-hide>
            <div style="height: 100%">
                <order-print v-if="modalPrint" :orderInput="orderInfo" @handleClose="handlePrintClose"></order-print>
            </div>
        </Modal>
    </div>
</template>

<script>
import {queryOrderDetail} from "@/api/business"
import Decimal from "decimal.js"
import OrderPrint from "@/components/Business/OrderPrint"

export default {
    name: "OrderDetail",
    components: {
        OrderPrint,
    },
    props: {
        orderInput: {
            type: Object,
        },
    },
    data() {
        return {
            orderInfo: {},
            carInfo: {},
            memberInfo: {},
            itemList: [],
            materList: [],
            statusBackground: '',
            receivePrice: [],
            modalPrint: false,
        }
    },
    mounted() {
        this.initInfo()
    },
    methods: {
        initInfo() {
            this.receivePrice = []
            queryOrderDetail(this.orderInput).then((res) => {
                this.orderInfo = res.data.workOrder
                this.carInfo = res.data.carInfo
                this.memberInfo = res.data.memberInfo
                this.itemList = res.data.itemInfoList
                for (let item of this.itemList) {
                    this.materList.push(...item.materialsInfoList)
                }
                let wechat = {
                    type: '微信支付',
                    price: this.orderInfo.wechatPrice,
                }
                this.receivePrice.push(wechat)

                let alipay = {
                    type: '支付宝支付',
                    price: this.orderInfo.alipayPrice,
                }
                this.receivePrice.push(alipay)

                let cash = {
                    type: '现金支付',
                    price: this.orderInfo.cashPrice,
                }
                this.receivePrice.push(cash)

                let card = {
                    type: '刷卡支付',
                    price: this.orderInfo.cardPrice,
                }
                this.receivePrice.push(card)

                let balance = {
                    type: '余额扣除',
                    price: this.orderInfo.balancePrice,
                }
                this.receivePrice.push(balance)

                let credit = {
                    type: '挂账',
                    price: this.orderInfo.creditPrice,
                }
                this.receivePrice.push(credit)
            })
        },
        onClose() {
            this.$emit('handleClose', false)
        },
        handlePrintClose() {
            this.modalPrint = false
        },
        getPriceMethodText(method) {
            if (method === 1) {
                return "工时计价"
            }
            return "金额计价"
        },
        getStatusText() {
            switch (this.orderInfo.status) {
                case 2:
                    this.statusBackground = '#f5ad14'
                    return '待付款'
                case 3:
                    this.statusBackground = '#e82854'
                    return '已挂账'
                case 5:
                    this.statusBackground = '#5cb85c'
                    return '已完成'
                default:
                    this.statusBackground = '#044aa1'
                    return '维修中'
            }
        },
        getManHourTotal() {
            let mHour = 0
            for (let item of this.itemList) {
                if (item.priceMethod === 1) {
                    mHour += item.preManhour
                }
            }
            return mHour
        },
        getItemTotalPrice() {
            let total = new Decimal(0)
            for (let item of this.itemList) {
                total = total.add(item.totalPrice)
            }
            return total
        },
        getItemTotalCount() {
            let count = 0
            for (let item of this.itemList) {
                count += item.count
            }
            return count
        },
        getItemMaterTotalPrice(mater) {
            return new Decimal(mater.actualSellPrice).mul(mater.count)
        },
        getMaterTotalCount() {
            let count = 0
            for (let mater of this.materList) {
                count += mater.count
            }
            return count
        },
        getMaterTotalPrice() {
            let price = new Decimal(0)
            for (let mater of this.materList) {
                price = price.add(this.getItemMaterTotalPrice(mater))
            }
            return price
        },
    },
}
</script>

<style scoped>
.container {
    width: 80%;
    margin: 0 auto;
    height: 100%;
    overflow: visible;
}

.top-banner {
    background: #044aa1;
    height: 38px;
    line-height: 38px;
    color: #ffffff;
    padding: 0 10px;
}

.car-info {
    padding: 10px 20px;
    margin-top: 10px;
    border: 1px solid #e6e6e6;
}

.back-button {
    border: 1px solid #e6e6e6;
    font-size: 12px;
    padding: 0 10px;
    position: relative;
    border-radius: 3px;
    cursor: pointer;
    margin-left: 10px;
    float: right;
    height: 26px;
    margin-top: 6px;
    line-height: 26px;
}

.order-status {
    display: inline-block;
    margin-left: 10px;
    font-size: 11px;
    vertical-align: middle;
    background: #044aa1;
    color: #ffffff;
    border-radius: 2px;
    padding: 0 5px;
    height: 22px;
    line-height: 22px;
}

.car-brand {
    color: #97a8be;
    font-size: 11px;
    margin-right: 5px;
}

.order-type {
    background: #2d8cf0;
    color: #ffffff;
    display: inline-block;
    padding: 0 8px;
    font-size: 12px;
    border-radius: 2px;
    margin-left: 10px;
    vertical-align: top;
    position: relative;
    top: 3px;
    height: 22px;
    line-height: 22px;
}

.car-info-detail {
    background: #f3f7fd;
    margin-top: 10px;
    padding: 10px 10px 15px 10px;
    border: 1px solid #dce6f5;
}

.car-info-title {
    font-weight: bold;
    text-align: right;
    padding-right: 15px;
    font-size: 13px;
    color: #202020;
}

.car-info-value {
    font-size: 13px;
    color: #505050;
}

.big-title {
    margin: 25px 0 10px 0;
    font-size: 18px;
    font-weight: bold;
}

.table-container {
    display: flex;
}

.table-left-title {
    writing-mode: vertical-rl;
    text-orientation: upright;
    text-align: center;
    min-height: 60px;
    width: 50px;
    line-height: 50px;
    border: 1px solid #e6e6e6;
}

.table-content {
    min-height: 60px;
    width: calc(100% - 50px);
    border: 1px solid #e6e6e6;
    border-left: none;
}

.table-row {
    text-align: center;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-top: 1px solid #e6e6e6;
}

.table-header {
    background: #d7d7d7;
    font-size: 13px;
    font-weight: bold;
}

.cell-border-left {
    border-left: 1px solid #e6e6e6;
}

.cell-border-right {
    border-right: 1px solid #e6e6e6;
}

.cell-border-both {
    border-left: 1px solid #e6e6e6;
    border-right: 1px solid #e6e6e6;
}

.print-button {
    float: right;
    border: 1px solid #bbbbbb;
    padding: 3px 10px;
    cursor: pointer;
}
</style>
